const PmiStructureEnum = Object.freeze({
    AIF: 'AIF',
    FUND: 'FUND',
    LIMITED_PARTNERSHIP: 'LIMITED_PARTNERSHIP',
    LTAF: 'LTAF',
    PRODUCT: 'PRODUCT',
    SICAV: 'SICAV',
    ELTIF: 'ELTIF',
    UNIT_TRUST: 'UNIT_TRUST'
});

export default PmiStructureEnum;
